import { render, staticRenderFns } from "./SysCfg.vue?vue&type=template&id=64242cf0&scoped=true&"
import script from "./SysCfg.vue?vue&type=script&lang=js&"
export * from "./SysCfg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64242cf0",
  null
  
)

export default component.exports